import React from "react";
import './palette.css'

function DashedLine(){
    return(
        <div className="dashed-line"/>
    )

}

export default DashedLine;